module.exports = __webpack_public_path__ + "img/migu.8b137011.png";